import Tooltip from './Tooltip'

export default Tooltip



// WEBPACK FOOTER //
// ./src/app/components/common/tooltip/index.js